<template>
  <button
    aria-controls="drawer"
    :aria-expanded="show"
    :class="['burger', { open: show }]"
    @click="toggleMenu"
  >
    <span />
    <span />
    <span />
    <span />
    <span
      aria-live="polite"
      class="is-sr-only"
      v-text="show ? 'close menu' : 'open menu'"
    />
  </button>
</template>

<script>
  import { eventBus } from '@Foundation/eventbus/eventbus';
  export default {
    name: 'Burger',
    data() {
      return {
        show: false,
      };
    },
    methods: {
      toggleMenu() {
        this.show = !this.show;

        eventBus.$emit('toggle-drawer', this.show);
      },
    },
  };
</script>
